import { useEffect, useState } from "react";

//components
import { Typography, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import Lottie from "react-lottie";
//hooks
import { useTimelines } from "hooks/timeline";
import { useTimelinePreferences, usePreferenceDetails } from "hooks/preference";
//providers
import { useTimelineState } from "providers/TimelineProvider";
import { usePreferenceState } from "providers/PreferenceProvider";
//assets
import loadingAnimation from "assets/lotties/rightPanelLoading.json";

const styles = {
  inputField: {
    color: "#55ff55",
    borderColor: "#55ff55",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "5px",
    padding: "0.5%",
    width: "100%",
    margin: "1%",
  },
};

function Goto({
  setRightState,
  band,
  setActiveTab,
  frequency,
  currentTypingFocus,
  setCurrentTypingFocus,
  resetInputValues,
}) {
  const [isEnteringFrequency, setIsEnteringFrequency] = useState(true);
  const [remainingUrlsToCache, setRemainingUrlsToCache] = useState([]);
  const [cachedUrls, setCachedUrls] = useState([]);
  const [timeline, setTimeline] = useTimelineState();
  const [preferences, setPreferences] = usePreferenceState();
  const [timelines, setTimelines] = useState([]);
  const [selectedTimeline, setSelectedTimeline] = useState(null);
  const [selectedTimelinePreferences, setSelectedTimelinePreferences] =
    useState(null);
  const { mutate, isLoading } = useTimelines();
  const { mutate: mutatePreferences, isLoading: isLoadingPreferences } =
    useTimelinePreferences();
  const {
    mutate: mutatePreferenceDetails,
    isLoading: isLoadingPreferenceDetails,
  } = usePreferenceDetails();

  const [blinkingCursor, setBlinkingCursor] = useState(false);

  useEffect(() => {
    const blinkingCursorInterval = setInterval(() => {
      setBlinkingCursor((current) => !current);
    }, 500);

    return () => {
      clearInterval(blinkingCursorInterval);
    };
  }, []);

  // useEffect(() => {
  //   mutate(
  //     { band: band || "original" },
  //     {
  //       onSuccess: (response) => {
  //         if (response && response.status === "OK") {
  //           setTimelines(response.timelines);
  //         }
  //       },
  //       onError: (error) => {
  //         console.log(error);
  //       },
  //     }
  //   );
  // }, [band, mutate]);

  useEffect(() => {
    if (selectedTimeline) {
      mutatePreferences(
        { timelineId: selectedTimeline._id },
        {
          onSuccess: (response) => {
            if (response && response.status === "OK") {
              setSelectedTimelinePreferences(response.preferences);
            }
          },
        }
      );
    }
  }, [selectedTimeline, mutatePreferences]);

  useEffect(() => {
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data.type === "CACHE_CHECK_RESPONSE") {
        if (!event.data.ok) {
          setRemainingUrlsToCache((current) => [...current, event.data.url]);
          navigator.serviceWorker.ready.then((res) =>
            res.active.postMessage({
              type: "CACHE_URL",
              url: event.data.url,
              cacheTitle: event.data.cacheTitle,
            })
          );
        }
        if (event.data.ok) {
          setCachedUrls((current) => [...current, event.data.url]);
        }

        return;
      }
      if (event.data.type === "URL_CACHE_COMPLETE") {
        setCachedUrls((current) => [...current, event.data.url]);
        setRemainingUrlsToCache((current) =>
          current.filter((url) => url !== event.data.url)
        );
      }
    });
  }, []);

  return <>
    {isLoading || isLoadingPreferenceDetails ? (
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: loadingAnimation,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
          initialSegment: [11, 121],
        }}
        height={"100%"}
        width={"80%"}
      />
    ) : isEnteringFrequency ? (
      <Grid
        Container
        style={{
          height: "100%",
          padding: "5%",
          paddingTop: "0%",
          alignSelf: "center",
          paddingRight: "10%",
        }}
      >
        <Grid
          container
          spacing={2}
          style={{ width: "100%", height: "100%", alignItems: "center" }}
        >
          <Grid item xs={10}>
            <Grid
              item
              container
              style={{ height: "50%", alignItems: "center" }}
            >
              <Grid item xs={6}>
                <Typography style={{ color: "wheat", align: "center" }}>
                  Frequency
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  variant="standard"
                  id="frequencyInput"
                  // label="Frequency"
                  value={`${frequency}${
                    currentTypingFocus === "frequency" && blinkingCursor
                      ? "_"
                      : ""
                  }`}
                  InputProps={{
                    readOnly: true,
                    style: styles.inputField,
                  }}
                  InputLabelProps={{
                    style: { color: "wheat" },
                  }}
                  onClick={() => {
                    setCurrentTypingFocus("frequency");
                  }} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2}>
            <Grid
              item
              container
              style={{ height: "100%", alignItems: "center" }}
            >
              <Button
                type="submit"
                size="large"
                style={{
                  backgroundColor: "#55ff5500",
                  color: "#00FF00",
                  borderColor: "#00FF00",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  margin: "1%",
                  height: "100%",
                  padding: "1%",
                }}
                variant="contained"
                onClick={() => {
                  mutate(
                    { band: band || "original", frequency },
                    {
                      onSuccess: (response) => {
                        if (response && response.status === "OK") {
                          // console.log(response)
                          setTimelines(response.timelines);
                          setIsEnteringFrequency(false);
                          resetInputValues();
                        }
                      },
                      onError: (error) => {
                        // console.log(error);
                      },
                    }
                  );
                }}
              >
                Go
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    ) : (
      <Grid
        container
        columnSpacing={2}
        style={{
          height: "100%",
          width: "100%",
          alignSelf: "center",
          padding: "1% 6% 0% 6%",
          overflow: "auto",
        }}
      >
        <Grid item xs={12}>
          {timelines.map((timeline, index) => {
            return (
              <>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    padding: "1%",
                    margin: "1%",
                    borderColor: "#55ff55",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    backgroundColor:
                      timeline._id === selectedTimeline?._id &&
                      remainingUrlsToCache.length === 0
                        ? "#22ff22"
                        : "#55ff5500",
                  }}
                  onClick={() => {
                    setSelectedTimeline(timeline);
                    let urls = Object.entries(timeline.layers)
                      .map(([layerName, layer]) => layer.url)
                      .filter((url) => url);
                    for (let url of urls) {
                      navigator.serviceWorker.ready.then((registration) =>
                        registration.active.postMessage({
                          type: "CACHE_CHECK",
                          cacheTitle: timeline.title.replace(" ", ""),
                          url,
                        })
                      );
                    }
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      display:
                        timeline._id !== selectedTimeline?._id && "none",
                      left: "3%",
                      height: "10%",
                      top: "85%",
                      width: `${
                        (94 /
                          (remainingUrlsToCache.length + cachedUrls.length)) *
                        cachedUrls.length
                      }%`,
                      backgroundColor: "#55ff55",
                    }}
                  >
                    &nbsp;
                  </div>
                  <Typography
                    variant="body2"
                    style={{
                      color:
                        timeline._id === selectedTimeline?._id &&
                        remainingUrlsToCache.length === 0
                          ? "#000000"
                          : "#55ff55",
                    }}
                  >
                    {index + 1}. {timeline.title}***
                    {new Date(timeline.createdAt).toLocaleDateString()}***
                    {new Date(timeline.updatedAt).toLocaleString()}
                  </Typography>
                </div>
                {timeline?._id === selectedTimeline?._id &&
                  selectedTimelinePreferences &&
                  remainingUrlsToCache.length === 0 && (
                    <div
                      style={{
                        paddingLeft: "10%",
                      }}
                    >
                      {selectedTimelinePreferences.map(
                        (preference, index) => {
                          return (
                            <div
                              style={{
                                width: "100%",
                                padding: "1%",
                                margin: "1%",
                                borderColor: "#55ff55",
                                borderWidth: "1px",
                                borderStyle: "solid",
                              }}
                              onClick={() => {
                                if (remainingUrlsToCache.length > 0) return;

                                mutatePreferenceDetails(
                                  { preferenceId: preference._id },
                                  {
                                    onSuccess: (response) => {
                                      if (
                                        response &&
                                        response.status === "OK"
                                      ) {
                                        setPreferences(response.preference);
                                        setTimeline(timeline);
                                        setActiveTab(0);
                                        setRightState("navigator");
                                      }
                                    },
                                  }
                                );
                              }}
                            >
                              <Typography
                                variant="body2"
                                style={{
                                  color: "#55ff55",
                                }}
                              >
                                {index + 1}.
                                {new Date(
                                  preference.createdAt
                                ).toLocaleDateString()}
                                ***
                                {new Date(
                                  preference.updatedAt
                                ).toLocaleString()}
                              </Typography>
                            </div>
                          );
                        }
                      )}
                    </div>
                  )}
              </>
            );
          })}
        </Grid>
      </Grid>
    )}
  </>;
}

export default Goto;
